import {
  useEffect,
  useState,
} from "react";

export const useConfiguration = () => {
  const [env, setEnv] = useState<NodeJS.ProcessEnv | null>(null);

  useEffect(() => {
    const readConfigFile = async () => {
      if (process.env.NODE_ENV === "development") {
        setEnv({
          SENTINEL_API: process.env.SENTINEL_API,
          SENTINEL_KEYCLOAK_URL: process.env.SENTINEL_KEYCLOAK_URL,
          SENTINEL_KEYCLOAK_CLIENT_ID: process.env.SENTINEL_KEYCLOAK_CLIENT_ID,
          SENTINEL_KEYCLOAK_REALM: process.env.SENTINEL_KEYCLOAK_REALM,
          SENTINEL_FEATURE_GANTT: process.env.SENTINEL_FEATURE_GANTT,
          SENTINEL_HOTJAR_ID: process.env.SENTINEL_HOTJAR_ID,
          SENTINEL_HOTJAR_VERSION: process.env.SENTINEL_HOTJAR_VERSION,
          SENTINEL_NPS_URL: process.env.SENTINEL_NPS_URL,
          SENTINEL_NPS_PRODUCT_ID: process.env.SENTINEL_NPS_PRODUCT_ID,
          SENTINEL_NPS_PRODUCT_NAME: process.env.SENTINEL_NPS_PRODUCT_NAME,
        });
      } else {
        const url = new URL(
          "./assets/configuration/configuration.json",
          window.location.origin
        );

        const response = await fetch(url.toString());
        const config = await response.json() as NodeJS.ProcessEnv;

        setEnv(config);
      }
    };

    void readConfigFile();
  }, []);

  return env;
};
